import { epic$, store } from "@redux/store";
import updateUrlEpic from "./redux/epics";
import {
  selectCurrentUrl,
  selectRoutingState,
  selectUrlLocation,
  urlComponentsSelector,
  urlFilterSelector,
  selectUrlSubdirectory,
  selectMapCoordinatesQueryString
} from "./redux/selectors";
import routingStateSlice from "./redux/slices";
import { buildNewUrl, getPaging, getBrandName } from "./services/urlBuilder";

require("./redux/listeners");
require("./components/pageLinkHandler");

const { actions: routingStateActions, reducer } = routingStateSlice;
epic$.next(updateUrlEpic);
store.injectReducer("routingState", reducer);

const routingSelectors = {
  urlComponentsSelector,
  selectCurrentUrl,
  selectUrlLocation,
};

export {
  routingStateActions,
  routingSelectors,
  selectUrlSubdirectory,
  getPaging,
  buildNewUrl,
  getBrandName,
  selectRoutingState,
  urlFilterSelector,
  selectCurrentUrl,
  selectMapCoordinatesQueryString
};
